import { useTranslation } from 'react-i18next';

import { DeclaredUnit } from '../../../../../../shared/interfaces/IComponentDetails';

type ProductMassProps = {
  declaredUnit?: DeclaredUnit;
  productMass?: number | null;
};

const ProductMass = (props: ProductMassProps): JSX.Element => {
  const { productMass, declaredUnit } = props;

  const { t } = useTranslation();

  // A derived mass of 0 is a real value, so only an absent mass counts as not specified
  if (declaredUnit == null || productMass == null) {
    return <span className='font-light text-black-alpha-60'>{t('global.notSpecified')}</span>;
  }

  return (
    <span className='font-light text-black-alpha-60'>
      {productMass} {DeclaredUnit.kilogram}
    </span>
  );
};

export default ProductMass;
